import React, { useEffect, useState } from 'react';
import {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import ElectronicVaccinationList from '../../../Nczi/Components/ElectronicVaccination/List/ElectronicVaccinationList';
import NCZIPatient from '../../../Nczi/Components/NCZIPatient/NCZIPatient';

interface Props {
	patientId: string;
	setIsLoading: (isLoading: boolean) => void;
}

const ElectronicVaccination: React.FC<Props> = ({
	patientId,
	setIsLoading,
}) => {
	const [steps, setSteps] = useState<NavigationStepperItemType[]>([]);

	useEffect(() => {
		handleLoadSteps();
	}, []);

	const handleLoadSteps = () => {
		const tempSteps: NavigationStepperItemType[] = [
			{
				name: 'patientTreatment.electronicVaccination.list.title',
				key: 'list',
				component: (params: NavigationStepperComponentParams) => (
					<NCZIPatient>
						<ElectronicVaccinationList setIsLoading={setIsLoading} />
					</NCZIPatient>
				),
			},
		];

		setSteps(tempSteps);
	};

	if (!steps.length) {
		return <></>;
	}

	return (
		<>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath='list'
				canSkip={true}
			/>
		</>
	);
};

export default ElectronicVaccination;
